import React, { useEffect } from 'react';
import { TOKEN_KEY } from '@/common/constant';
import { removeLocalStorageValue } from '@/common/utils';

export default function Logout() {
  useEffect(() => {
    removeLocalStorageValue(TOKEN_KEY);
    setTimeout(() => {
      window.location.href = '/';
    }, 0);
  }, []);

  return <div>Logout...</div>;
}
